/**
 * 효과음 — Web Audio 합성(무에셋, $0). localStorage 토글 존중. 미지원/꺼짐/에러 시 무음 no-op.
 * reduced-motion과 별개(시각 모션이 아니라 청각). 기본 ON, 토글로 OFF.
 */
const KEY = 'bq.sound';

export function isSoundEnabled(): boolean {
  try { return localStorage.getItem(KEY) !== 'off'; } catch { return false; }
}
export function setSoundEnabled(on: boolean): void {
  try { localStorage.setItem(KEY, on ? 'on' : 'off'); } catch { /* ignore */ }
}

let ctx: AudioContext | null = null;
function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AC) return null;
  try { if (!ctx) ctx = new AC(); return ctx; } catch { return null; }
}

function tone(c: AudioContext, freq: number, startOffset: number, dur: number, gain = 0.05): void {
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  const t0 = c.currentTime + startOffset;
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
}

export type SoundEvent = 'correct' | 'wrong' | 'levelup' | 'celebrate' | 'badge';

const SEQ: Record<SoundEvent, [number, number, number][]> = {
  correct:   [[660, 0, 0.12]],
  wrong:     [[180, 0, 0.18]],
  levelup:   [[523, 0, 0.1], [784, 0.1, 0.16]],
  celebrate: [[523, 0, 0.1], [659, 0.1, 0.1], [784, 0.2, 0.22]],
  badge:     [[880, 0, 0.12], [1175, 0.1, 0.14]],
};

export function playSound(ev: SoundEvent): void {
  if (!isSoundEnabled()) return;
  const c = getCtx();
  if (!c) return;
  try {
    if (c.state === 'suspended') void c.resume();
    for (const [f, s, d] of SEQ[ev]) tone(c, f, s, d);
  } catch { /* never block UX on sound */ }
}
